import React, { FC, useCallback } from 'react';
import { Button, Modal, Steps } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Icons from '@ant-design/icons';
import { useStatusMap } from '@modules/status';
import { tableSetFiltersAction } from '../../../../actions/table';

export const DeclarationTimeline: FC<{ onClose: () => void; id: string }> = ({ onClose, id }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data } = useStatusMap(2, id);

  const makeDescription = useCallback(({ date, executor, name }) => {
    if (!date || !executor) {
      return undefined;
    }
    return `Bağlama "${date}" tarixində "${executor}" tərəfindən "${name}" statusuna keçirilmişdir`;
  }, []);

  const makeStatus = useCallback(({ current, date }) => {
    return current ? 'process' : !!date ? 'finish' : 'wait';
  }, []);

  const openLogs = useCallback(() => {
    dispatch(
      tableSetFiltersAction('logs', [
        {
          id: 'model_name',
          value: 'Bağlamalar',
        },
        {
          id: 'object_id',
          value: id,
        },
      ]),
    );
    history.push(`/@next/logs?object_id=${id}&model_id=2`);
  }, [history, dispatch, id]);

  const openStatusHistory = useCallback(() => {
    dispatch(
      tableSetFiltersAction('stateArchive', [
        {
          id: 'model_name',
          value: 'Bağlamalar',
        },
        {
          id: 'object_id',
          value: id,
        },
      ]),
    );
    history.push(`/@next/archive/state?object_id=${id}&model_id=2`);
  }, [history, dispatch, id]);

  if (!data) {
    return null;
  }

  const footer = (
    <React.Fragment>
      <Button onClick={openLogs} icon={<Icons.HistoryOutlined />}>
        Əməliyyat tarixçəsi
      </Button>
      <Button onClick={openStatusHistory} icon={<Icons.FieldTimeOutlined />}>
        Status tarixçəsi
      </Button>
    </React.Fragment>
  );

  return (
    <Modal visible={true} width={576} onCancel={onClose} footer={footer} title='Status xəritəsi'>
      <Steps progressDot={true} direction='vertical'>
        {data?.map((item) => (
          <Steps.Step
            key={item.id}
            status={makeStatus({ current: false, date: item.createdAt })}
            title={item.state.name}
            subTitle={item.user.name}
            description={makeDescription({
              name: item.state.name,
              executor: item.user.name,
              date: item.createdAt,
            })}
          />
        ))}
      </Steps>
    </Modal>
  );
};
